// extracted by mini-css-extract-plugin
export default {"Error404":"Error-404_Error404__He+bO"};